import { render, staticRenderFns } from "./ViberBusinessMessagesInfo.vue?vue&type=template&id=422c8444&"
import script from "./ViberBusinessMessagesInfo.vue?vue&type=script&lang=js&"
export * from "./ViberBusinessMessagesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports